import React, { FC, useMemo, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';
import Application from 'src/front/components/Application';

import { StepperRefProps } from 'src/front/components/StepperView';
import OnlinePosProvider from 'src/front/contexts/OnlinePosContext';
import Activation from './Activation';
import CardSearch from './CardSearch';

export interface CustomerInfo {
  customerId: string;
  customerNumber: string;
  cardNumber: string;
  cardId: string;
  cardStatus: string;
}

const OnlinePosActivation: FC = () => {
  const { t } = useTranslation();
  const stepperRef = useRef<StepperRefProps>(null);

  const [customerInfo, setCustomerInfo] = useState<CustomerInfo>();
  const [isCompleted, setIsCompleted] = useState<boolean>(false);

  const goToNextStep = (
    customerId: string,
    customerNumber: string,
    cardNumber: string,
    cardId: string,
    cardStatus: string
  ): void => {
    setCustomerInfo({ customerId, customerNumber, cardNumber, cardId, cardStatus });
    stepperRef.current?.goToNextStep();
  };

  const goToPreviousStep = (): void => {
    stepperRef.current?.goToPreviousStep();
  };

  const steps = [
    {
      component: () => <CardSearch goToNextStep={goToNextStep} />,
    },
    {
      component: () => (
        <Activation
          customerInfo={customerInfo}
          goToPreviousStep={goToPreviousStep}
          setIsCompleted={setIsCompleted}
        />
      ),
    },
  ];

  const stepsVertical = useMemo(() => {
    return [
      {
        index: 1,
        text: t('posActivation_stepper_cardSearch_text'),
      },
      {
        index: 2,
        text: t('posActivation_stepper_posActivation_text'),
      },
    ];
  }, [t]);

  return (
    <OnlinePosProvider>
      <Application
        isCompleted={isCompleted}
        stepperRef={stepperRef}
        steps={steps}
        stepsVertical={stepsVertical}
      />
    </OnlinePosProvider>
  );
};

export default OnlinePosActivation;
